module.exports = __webpack_public_path__ + "static/media/headerLogo.e02d552e.png";